import { defineMessages } from 'react-intl';

const masterpassMessages = defineMessages({
    payWithMasterpass: {
        id: 'masterpass.masterpassMessages.payWithMasterpass',
        description: 'Button to use Masterpass as the payment method',
        defaultMessage: 'Buy with Masterpass'
    }
});

export default masterpassMessages;
